// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3-LBT","tab":"Tabs_tab__3tVSn","tabActive":"Tabs_tabActive__3Q_eF"};